import React from 'react';
import { Row } from 'react-bootstrap';
import bg1 from '../../../../images/art16.png';
import bg2 from '../../../../images/art10.png';
import bg3 from '../../../../images/art2.png';

const LiveDelhi = () => {
  return (
    <>
      <div className='LiveEvents-imgs'>
        <div>
          <img src={bg1} alt='' width='160px' height='100px' />
        </div>
        <div>
          <img src={bg2} alt='' width='160px' height='100px' />
        </div>
        <div>
          <img src={bg3} alt='' width='160px' height='100px' />
        </div>
      </div>
      <Row className='my-2 live_Event-text'>
        <h2 className='text-capitalize mt-4 mb-0 ml-2 pt-2 pb-0'>venue</h2>
      </Row>
      <div className='text-light my-1 live_Event-text'>
        <h4 className='text-capitalize mt-2 mb-0 ml-0 py-2'>Kitty Su</h4>
        <p className='mb-0'>Barakhamba Road </p>
        <p>Delhi</p>
      </div>
    </>
  );
};
export default LiveDelhi;
